import { Divider, Grid, Switch } from '@mui/material';
import { Field, FieldProps, useFormikContext } from 'formik';
import { FormControlLabel } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { FormikPoolDatePicker, PoolTypography } from '@synergy/components';
import { ReactElement } from 'react';
import { Stack } from '@mui/material';
import { fields } from '@synergy/utils';

import { CustomerConditionsFormValues } from '../models/customer-conditions-form-values';

const fieldNames = fields<CustomerConditionsFormValues>();

export const CustomerDetailConditionsMemberSince = (): ReactElement => {
    const formik = useFormikContext<CustomerConditionsFormValues>();

    return (
        <Grid container={true}>
            <Grid item={true} xs={12}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <Stack direction="row" alignItems="center">
                        <Field name={fieldNames.isMember}>
                            {({ field, form }: FieldProps<boolean>) => (
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={field.value}
                                            value="member"
                                            color="primary"
                                            onClick={() => {
                                                const value = !field.value;
                                                if (!value) {
                                                    form.setFieldValue(fieldNames.memberSince, null);
                                                }
                                                form.setFieldValue(fieldNames.hasBonusPayout, !field.value);
                                                form.setFieldValue(field.name, !field.value);
                                            }}
                                        />
                                    }
                                    label=""
                                    sx={{ height: 20, marginRight: 0 }}
                                />
                            )}
                        </Field>
                        <PoolTypography typography="h6" id="app.common.member" />
                    </Stack>

                    <Stack direction="row" alignItems="center">
                        <Field name={fieldNames.hasBonusPayout}>
                            {({ field, form }: FieldProps<boolean>) => (
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={field.value}
                                            value="bonusPayout"
                                            color="primary"
                                            onClick={() => {
                                                form.setFieldValue(field.name, !field.value);
                                            }}
                                        />
                                    }
                                    label=""
                                    sx={{ height: 20, marginRight: 0 }}
                                />
                            )}
                        </Field>
                        <PoolTypography
                            typography="body2"
                            id="app.contactsAndOrganizations.conditions.bonus.bonusPayout"
                        />
                    </Stack>
                </Stack>
                <Divider sx={{ mt: 1, mb: 2, backgroundColor: theme => theme.palette.text.primary }} />
            </Grid>

            <Grid item={true} xs={4}>
                <FormikPoolDatePicker
                    name={fieldNames.memberSince}
                    label={<FormattedMessage id="app.contactsAndOrganizations.conditions.memberSince" />}
                    required={formik.values.isMember}
                    disabled={!formik.values.isMember}
                />
            </Grid>
        </Grid>
    );
};
